/**
 * Detect fn
 */
export default () =>
  'Symbol' in self && 'iterator' in self.Symbol && !!Array.prototype.keys
